/*
 * Filename: transfer-rule.component.tsx
 * Description: Component for hidden rule.
 */


import { CQAppConstant } from '../../../app-constants';

export class CQTransferRuleController {

    public ruleJSON: any = {};

    constructor(ruleArray: any, eventType?: string) {
        this.formRuleJson(ruleArray.setValues, ruleArray.isChecked, eventType);
    }

    /**
     * @private
     * Generate form JSON form rules
     * @function formRuleJson
     * @param { obj } setValueRuleData contains details related to setValues object
     * @param { boolean } shouldSkip determins should skip the checking of filtering process
     * @param { string } eventType
     * @returns { obj } JSON format of form rule
     * @memberof CQTransferRuleController
     */
    private formRuleJson = (setValueRuleData: any, shouldSkip :boolean, eventType?: string) => {

        const setValueRule: any = this.formRuleFilter(setValueRuleData, shouldSkip);
        if (eventType) {
            this.ruleJSON = {
                [eventType]: { 'transfer': setValueRule }
            };
        } else {
            this.ruleJSON = {
                'transfer': setValueRule
            };
        }

        return this.formRuleJson;
    }

    /**
    * @memberof CQTransferRuleController
    */
    public formRuleFilter = (setValueRuleData: any, shouldSkip :boolean) => {
        const setValues: any[] = [];
        setValueRuleData.forEach((setValueSection: any) => {
            const fields: string[] = [];
            let setValuesObject = { fields, filter: '', action: {} };
            setValueSection.addedCriterias.forEach((criteria: any) => {
                const fieldName = criteria.field.split('-')[0];
                if(!setValuesObject.fields.includes(fieldName)){
                    setValuesObject.fields.push(fieldName);
                }

                if (criteria.isDynamic
                    && criteria.operator !== CQAppConstant.EXISTS
                    && criteria.operator !== CQAppConstant.ISEMPTY) {
                    const fieldName = criteria.compareTo.split('-')[0];
                    if(!setValuesObject.fields.includes(fieldName)){
                        setValuesObject.fields.push(fieldName);
                    }
                }
            });
            
            if(setValueSection.shouldSkip){
                setValuesObject.filter = "true";
            }else{
                setValuesObject.filter = this.formFilterString(setValueSection.complexLogicQuery, setValueSection.addedCriterias);
            }

            let actions: any = {};
            setValueSection.actionArray.forEach((ruleObject: any) => {
                if (actions.hasOwnProperty(ruleObject.selectedLookupValue)) {
                    actions[ruleObject.selectedLookupValue].push(ruleObject.selectedLayoutField);
                } else {
                    actions = { ...actions, [ruleObject.selectedLookupValue]: [ruleObject.selectedLayoutField] };
                }
                if (ruleObject.lookupFieldRelationshipName !== '' && ruleObject.layoutFieldRelationshipName !== '' && ruleObject.layoutFieldRelationshipName ) {
                    if (actions.hasOwnProperty(ruleObject.lookupFieldRelationshipName)) {
                        actions[ruleObject.lookupFieldRelationshipName].push(ruleObject.layoutFieldRelationshipName);
                    } else {
                        actions = { ...actions, [ruleObject.lookupFieldRelationshipName]: [ruleObject.layoutFieldRelationshipName] };
                    }
                }
            });

            setValuesObject.action = actions;
            setValues.push(setValuesObject);
        });

        return setValues;
    }


    /**
    * @private
    * @param {string} complexLogic
    * @param {ICriteria[]} criterias
    * @returns
    * @memberof CQTransferRuleController
    */
    private formFilterString(complexLogic: string, criterias: any[]) {
        let filterJSExpression = this.replaceLogicOperators(complexLogic);
        const criteriaFilterString: string[] = [];
        const referenceFieldInCriteria: string[] = [];
        criterias.forEach((criteria: any, index: number) => {
            const operator = (criteria.operator !== CQAppConstant.EXISTS
                && criteria.operator !== CQAppConstant.ISEMPTY) ? criteria.operator : '';
            const fieldName = criteria.field.includes('-')?criteria.field.split('-')[1]:criteria.field;
            let recordStr = CQAppConstant.RECORD;
            if(fieldName === 'customSettings' || fieldName === 'userInfo.Id'){
                recordStr = '';
            }
            if (criteria.isDynamic && operator !== '') {
                const compareTo = criteria.compareTo.includes('-')?criteria.compareTo.split('-')[1]:criteria.compareTo;
                let recordStrCmpTo = (compareTo === 'userInfo.Id') ? '': CQAppConstant.RECORD;
                if ((CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType)) {
                    if(index === 0 && criteria.referenceField === ''){
                        criteriaFilterString.push(` ${recordStr}${fieldName} ${operator} ${recordStrCmpTo}${criteria.compareTo}`);
                    }else{
                        referenceFieldInCriteria.push(fieldName);
                        criteriaFilterString.push(` ${recordStr}${criteria.relationshipName}.${criteria.referenceField} ${operator} ${recordStrCmpTo}${criteria.compareTo}`);
                    }
                } else {
                    criteriaFilterString.push(` ${recordStr}${fieldName} ${operator} ${recordStrCmpTo}${compareTo}`);
                }
            } else {
                let isNumber = false;
                if (criteria.compareTo === true || criteria.compareTo === false || criteria.compareTo === '') {
                    isNumber = false;
                } else {
                    isNumber = !isNaN(criteria.compareTo);
                }

                if (((CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType)) && operator !== '') {
                    if(index === 0 && criteria.referenceField === ''){
                        criteriaFilterString.push(`${criteria.operator === CQAppConstant.ISEMPTY ? '!' : ''}${recordStr}${fieldName} ${operator} ${isNumber ? parseInt(criteria.compareTo)
                            : this.covertStringIfIBooleanType(criteria.compareTo)} `);
                    }else{
                        referenceFieldInCriteria.push(fieldName);
                        criteriaFilterString.push(`${criteria.operator === CQAppConstant.ISEMPTY ? '!' : ''}${recordStr}${criteria.relationshipName}.${criteria.referenceField} ${operator} ${isNumber ? parseInt(criteria.compareTo)
                            : this.covertStringIfIBooleanType(criteria.compareTo)} `);
                    }
                } else {
                    criteriaFilterString.push(`${criteria.operator === CQAppConstant.ISEMPTY ? '!' : ''}${recordStr}${fieldName} ${operator} ${isNumber ? parseInt(criteria.compareTo)
                        : this.covertStringIfIBooleanType(criteria.compareTo)} `);
                }
            }
        });
        if (criteriaFilterString.length > 1) {
            const numberMatches = complexLogic.match(/\d+/g);
            numberMatches?.forEach(match => {
                filterJSExpression = filterJSExpression.replace(match, `%%${match}%%`);
            });
            if (numberMatches) {
                numberMatches.forEach(match => {
                    filterJSExpression = filterJSExpression.replace(`%%${match}%%`, criteriaFilterString[parseInt(match) - 1]);
                });
            }
        } else if (criteriaFilterString.length === 1) {
            filterJSExpression = criteriaFilterString[0];
        }

        return referenceFieldInCriteria.length !== 0 ?
            this.constructFilterStringForRefereceCritetias(filterJSExpression, referenceFieldInCriteria) 
            :
            filterJSExpression;
    }

    private replaceLogicOperators(filterJSExpression: string) {
        const regExANDTerm = new RegExp(` ${CQAppConstant.AND_OPERATOR} `, 'g');
        const regExORTerm = new RegExp(` ${CQAppConstant.OR_OPERATOR} `, 'g');
        const regExandTerm = new RegExp(` ${CQAppConstant.AND_OPERATOR.toLowerCase()} `, 'g');
        const regExorTerm = new RegExp(` ${CQAppConstant.OR_OPERATOR.toLowerCase()} `, 'g');
        filterJSExpression = filterJSExpression.replace(regExANDTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.AND} `);
        filterJSExpression = filterJSExpression.replace(regExORTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.OR} `);
        filterJSExpression = filterJSExpression.replace(regExandTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.AND} `);
        filterJSExpression = filterJSExpression.replace(regExorTerm, ` ${CQAppConstant.LOGICAL_OPERATORS.OR} `);
        return filterJSExpression;
    }

    /**
    * @private
    * @param {string} text
    * @returns
    * @memberof CQTransferRuleController
    */
    private covertStringIfIBooleanType(text: string) {
        if (text === 'true') {
            return true;
        } else if (text === 'false') {
            return false;
        } else if (text === '') {
            return text;
        } else {
            return `'${text}'`;
        }
    }

    private constructFilterStringForRefereceCritetias(filterJSExpression: string, referenceFieldInCriteria: string[]) {
        let filterString = '';
        referenceFieldInCriteria = Array.from(new Set(referenceFieldInCriteria));
        referenceFieldInCriteria.forEach((referenceTypeField: string) => {
            filterString = `${filterString} ${referenceTypeField === "customSettings" ? '' : CQAppConstant.RECORD}${referenceTypeField} ${CQAppConstant.LOGICAL_OPERATORS.AND}`;
        });
        return `${filterString} (${filterJSExpression})`;
    }

}

